import yup from "@/yup";

export function usePSPSettingsSchema() {
  return yup.object({
    paymentGateway: yup
      .object({
        id: yup.number(),
      })
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === null ? {} : value;
      }),
    lobbySettings: yup.object({
      isDepositActive: yup.boolean(),
      isWithdrawActive: yup.boolean(),
    }),
  });
}

export type PSPSettingsSchema = yup.InferType<
  ReturnType<typeof usePSPSettingsSchema>
>;
